import React, { Component } from 'react'
import moment from 'moment'
import MediaQuery from 'react-responsive'

// Components
import Loading from '../../../loading/Loading'
import BackToOverview from '../../../backtooverview/BackToOverview'
import CoverImage from '../../../coverimage/CoverImage'
import LocationMap from './locationmap/LocationMap'

// JS
import { fetchExhibitionFromBackend } from '../../../../utils/rest'
import { MOBILEDEVICEWIDTH, DESKTOPTABLETDEVICEWIDTH } from '../../../../utils/constants'

// CSS
import './ExhibitionDetails.css'

class ExhibitionDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      exhibition: null
    }
  }

  componentWillMount() {
    this.fetchExhibition(this.props.match.params.string)
  }

  render() {
    if (this.state.exhibition) {
      return (
        <div className="details extra-margin">
          <MediaQuery minDeviceWidth={DESKTOPTABLETDEVICEWIDTH} className="desktop-content">
            <div className="information">
              <div className="information-container">
                <div className="information-content">
                  <h3>Location</h3>
                  <LocationMap
                    location={[this.state.exhibition.latitude, this.state.exhibition.longitude]}
                  />
                  <div className="location-description">{this.state.exhibition.address}</div>
                </div>
                <BackToOverview
                  url={"/exhibitions"}
                  text={"Back to exhibitions"}
                />
              </div>
            </div>
            <div className="content">
              <h3>{this.state.exhibition.title}</h3>
              <CoverImage
                image={this.state.exhibition.cover_image}
                title={this.state.exhibition.title}
              />
              <div dangerouslySetInnerHTML={{ __html: this.state.exhibition.body_text }} />
              <div className="posted-item">From: {moment(this.state.exhibition.start_date).format('DD-MM-YYYY HH:mm')} - {moment(this.state.exhibition.end_date).format('DD-MM-YYYY HH:mm')}</div>
            </div>
          </MediaQuery>

          <MediaQuery maxDeviceWidth={MOBILEDEVICEWIDTH} className="mobile-content">
            <div className="content">
              <h3>{this.state.exhibition.title}</h3>
              <CoverImage
                image={this.state.exhibition.cover_image}
                title={this.state.exhibition.title}
              />
              <div dangerouslySetInnerHTML={{ __html: this.state.exhibition.body_text }} />
              <div className="posted-item">From: {moment(this.state.exhibition.start_date).format('DD-MM-YYYY HH:mm')} - {moment(this.state.exhibition.end_date).format('DD-MM-YYYY HH:mm')}</div>
            </div>
            <div className="information-content">
              <h3>Location</h3>
              <LocationMap
                location={[this.state.exhibition.latitude, this.state.exhibition.longitude]}
              />
              <div className="location-description">{this.state.exhibition.address}</div>
            </div>
            <BackToOverview
              url={"/exhibitions"}
              text={"Back to exhibitions"}
            />
          </MediaQuery>
        </div>
      )
    } else {
      return (
        <Loading
          title={"exhibition"}
        />
      )
    }


  }

  receiveExhibitionError = (error) => {
    this.setState({ loading: false, error })
  }

  receiveExhibitionSuccess = (exhibition) => {
    this.setState({ loading: false, exhibition })
  }

  requestExhibition = () => {
    this.setState({ loading: true })
  }

  /**
   * Fetch projects from backend and set them in redux store
   */
  async fetchExhibition(url) {

    try {
      this.requestExhibition()

      const exhibition = await fetchExhibitionFromBackend(url)

      this.receiveExhibitionSuccess(exhibition)
    }
    catch (err) {
      this.receiveExhibitionError(err)
    }

  }
}

export default ExhibitionDetails;



// WEBPACK FOOTER //
// ./src/components/main/exhibition/exhibitiondetails/ExhibitionDetails.js